<template>
  <div>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="column"
      max-height="300px"
    >
    </vxe-grid>
  </div>
</template>
<script>
  // import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import API from '@/api/capitalCenter/receivablesManage';
  export default {
    name: 'orderInfo',
    props: [],
    components: {
      // SearchTable,
    },
    computed: {
      column() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '行项目号', width: 90 }, // 序号
          {
            field: 'docNo',
            title: this.$t('receivablesManage.orderInfo.docNo'),
            width: 120,
          }, // 收款单号
          {
            // 收款状态
            field: 'receiveStatus',
            title: this.$t('receivablesManage.orderInfo.receiveStatus'),
            width: 150,
            // dictType: 'receiveOrderStatus',
            /*             editRender: {
              name: 'ElSelect',
              options: this.receivedTypeOptions,
            }, */
          },
          {
            field: 'accountedDate',
            title: this.$t('receivablesManage.orderInfo.postTime'),
            width: 150,
          }, // 过账日期
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    mounted() {
      console.log('===', this.dictListMap?.receiveOrderStatus);
    },
    methods: {},
  };
</script>
